import { Grid, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../layoutPages/components/PageTitle';
import { Paragraph } from '../../layoutPages/containers/Paragraphs/Paragraph';
import { MaterialList } from '../../layoutPages/components/MaterialList';
import { reportData } from '../../data/ReportData';

export function PageReport() {
    const { category } = useParams<{ category: string }>();
    const page = category ? reportData[category] : undefined;

    if (!page) {
        return (
            <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
                <PageTitle title="計劃/報告" size="h3" />
                <Grid item xs={11} sm={10} sx={{ p: 2 }}>
                    <Typography>找不到此報告分類。</Typography>
                </Grid>
            </Grid>
        );
    }

    const data = page.items.map((item) => ({
        ...item,
        icon: <PictureAsPdfIcon sx={{ color: "red" }} />,
    }));

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <PageTitle title={`計劃/報告 | ${page.title}`} size="h3" />

            <Grid item xs={11} sm={10} sx={{ p: 2 }}>
                <Paragraph title="" sx={{ mt: 2 }} instantAppear
                    data={[<MaterialList data={data} />]}
                />
            </Grid>
        </Grid>
    );
}
